import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Send_email extends PureComponent {
  render() {
    return (
      <div className="row" id="send_email">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Email Send</h2>
              <p>
                Sending emails for requires a subject and the body. The body of
                the email is an HTML email body. Attachments at this stage are
                not supported. Emails will be sent from no-reply@app.nexoid.com
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Send Email Example</h2>
              <p>This example sends and email to fake.email@nexoid.com.</p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>
                .api.nexoid.com/v1/email/send
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"email"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"to"</span>:{" "}
                  <span className="jsonY">"fake.email@nexoid.com"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"subject"</span>:{" "}
                  <span className="jsonY">"Test Email Subject"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"body"</span>:{" "}
                  <span className="jsonY">
                    "Test email body here. This body could be an HTML or plain
                    text."
                  </span>
                </div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"to"</span>:{" "}
                  <span className="jsonY">"fake.email@nexoid.com"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"sent"</span>:{" "}
                  <span className="jsonP">true</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Send_email;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Send_email.js